// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"b4fd0c79","288":"814726f2","464":"8e58f63a","613":"7a7aab5d","854":"8bb3732f"}[chunkId] + ".chunk.js";
};